import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import axios from "axios";
import dropDown_icon from "../../assets/img/dropdown_icon_selector.svg";
import { Typography } from "@mui/material";
import colors from "colors/color";

const SplitButton = ({
  steps = [],
  currentStep,
  user_id,
  post,
  applicationId,
  status,
  email,
  onStepUpdate, // Add callback prop
}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;
  // Use steps prop or fallback to default options
  const options = steps.length > 0 ? steps : ["No steps available"];

  // Find the index of current step, default to 0 if not found
  const currentStepIndex = currentStep
    ? options.findIndex((step) => step === currentStep)
    : 0;
  const [selectedIndex, setSelectedIndex] = React.useState(
    currentStepIndex >= 0 ? currentStepIndex : 0
  );

  // Update selected index when currentStep changes
  React.useEffect(() => {
    if (currentStep) {
      const newIndex = options.findIndex((step) => step === currentStep);
      if (newIndex >= 0) {
        setSelectedIndex(newIndex);
      }
    }
  }, [currentStep, options]);

  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);
  };

  const handleMenuItemClick = (event, index) => {
    event.stopPropagation(); // Prevent card navigation
    setSelectedIndex(index);
    setOpen(false);
    console.info(
      `You selected ${options[index]} for application ${applicationId}`
    );
    updateApplicationStep(applicationId, options[index], status, email);

    // Call the updateApplicationStep function with the selected step
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleSendEmail = async (emailData) => {
    try {
      // Destructure email data

      const {
        user_id: user_id,
        to: receiver,
        subject,
        applicant_name,
        status,
        job_title,
        job_link,
        application_date,
      } = emailData;

      // Prepare payload for backend
      const payload = {
        user_id: user_id,
        to: receiver,
        subject,
        applicant_name,
        status,
        job_title,
        job_link,
        application_date,
      };
      console.log("here is the send data", payload);

      // Send email using backend API
      const response = await axios.post(
        `${apiUrl}authentication/api/send-email/`,
        payload
      );

      // Handle successful email sending
      console.log("Email sent successfully!");
      return response.data;
    } catch (error) {
      // Handle any errors in email sending
      console.error("Email sending failed:", error);
      alert(error.response?.data?.detail || "Failed to send email");
      throw error;
    }
  };

  const updateApplicationStep = async (
    applicationId,
    newStep,
    status,
    description
  ) => {
    try {
      const url =
        status !== "Application-Imported" && status !== "Scraping-Email" && status !== "Application Spontane"
          ? `${apiUrl}authentication/applications/${applicationId}/update-step/`
          : `${apiUrl}authentication/applicationsscraped/${applicationId}/update-step/`;

      console.log(
        "Updating application step:",
        "\n- Application ID:", applicationId,
        "\n- New Step:", newStep,
        "\n- Status:", status,
        "\n- URL:", url
      );
      
      const response = await axios.patch(
        url,
        { step: newStep },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.status === 200) {
        // Send email notification about step update
        const emailData = {
          user_id: user_id,
          to: description, // Assuming post has an email field for notifications
          applicant_name: "Dear Applicant",
          status: newStep,
          job_title: post.title || "Job",
          job_link: `${apiUrlFront}viewjob/${btoa(post)}`,
          application_date: new Date().toLocaleString(),
          subject: `Application Status Update -  ${newStep}`,
        };
        console.log("Email data to be sent:", emailData);
        await handleSendEmail(emailData);
        
        // Call the onStepUpdate callback if provided
        if (onStepUpdate && typeof onStepUpdate === 'function') {
          onStepUpdate();
        }
      }
    } catch (error) {
      console.error("Error updating application step:", error);
      console.error("Error details:", {
        applicationId,
        newStep,
        status,
        errorMessage: error.response?.data || error.message
      });
      
      // Show user-friendly error message
      if (error.response?.status === 404) {
        alert(`Cannot update step: Application ID ${applicationId} not found. This might be a scraped application that needs to be processed first.`);
      } else {
        alert(`Failed to update application step: ${error.response?.data?.detail || error.message}`);
      }
    }
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <React.Fragment>
      {/* <ButtonGroup
        sx={{
          width: "100%",
          display: "flex",
          // justifyContent: 'space-between',
          minHeight: 40,
        }}
        variant="contained"
        ref={anchorRef}
        aria-label="Button group with a nested menu"
      > */}
        <Button
          sx={{
            width: "70%",
            backgroundColor: "#C1000033",
            border: `1px solid #C10000`,
            boxShadow: 'none',
            borderRadius: "8px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleToggle();
          }}
          ref={anchorRef}
        >
          <Typography
            sx={{
              fontWeight: "400",
              color: '#C10000',
              textTransform: "none",
              fontFamily: "Poppins",
              mr: 2
            }}
          >
            {options[selectedIndex]}
          </Typography>

          <img src={dropDown_icon} alt="dropdown" />
        </Button>
        {/* <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select step"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button> */}
      {/* </ButtonGroup> */}
      <Popper
        sx={{ 
          zIndex: 1500,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper
              sx={{
                borderRadius: "8px",
                border: "1px solid #C10000",
                boxShadow: "0 4px 12px rgba(193, 0, 0, 0.15)",
                mt: 0.5,
                minWidth: anchorRef.current?.offsetWidth || 200,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList 
                  id="split-button-menu" 
                  autoFocusItem
                  sx={{
                    py: 0.5,
                  }}
                >
                  {options.map((option, index) => (
                    <MenuItem
                      key={index}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "0.875rem",
                        color: "#C10000",
                        py: 1.5,
                        px: 2,
                        "&:hover": {
                          backgroundColor: "#C1000015",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#C1000033",
                          fontWeight: 500,
                          "&:hover": {
                            backgroundColor: "#C1000045",
                          },
                        },
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
};

export default SplitButton;

// onUpdateStep(_card.id, destination.toColumnId, _card.status, _card.description);
